export const ReportVisibilityTypes = {
  Visible: "visible",
  Hidden: "hidden"
};
